/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../impl/DashboardFactory',
	'./Glass',
	'./Logger',
	'../../../features/dashboard/palette/PaletteAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../RuntimeEnvironment'
], function (BaseFactory, Glass, Logger, PaletteAPI, APIFactory, RuntimeEnvironment) {

	class GlassDashboardFactory extends BaseFactory{
		constructor(options = {}) {
			super();
			this.glassContext = options.glassContext || window.__glassAppController.glassContext;
			this.features = {};
		}

		initializeRuntime() {
			if (this.runtimeEnv){
				return Promise.resolve();
			} else {
				return this.getBootstrapFeatures().then((features) => {
					this.runtimeEnv = new RuntimeEnvironment(features);
					return this.runtimeEnv;
				});
			}
		}

		_initializeCapabilitiesFeature(glassFeature) {
			const packageCapabilityEnabled =  glassFeature.getCoreService('.FeatureChecker').checkValue('dashboard', 'packageCapability', 'enabled');
			if (packageCapabilityEnabled) {
				const currentPerspective = this.glassContext.currentPerspective.perspective;
				if (currentPerspective === 'explore') {
					// Explore doesn't support package capability in R7 stream
					return Promise.resolve(null);
				}
				return glassFeature.getService('.CapabilitiesService');
			}
			return Promise.resolve(null);
		}

		getBootstrapFeatures() {
			const glass = new Glass(this.glassContext);
			this.features = {
				Glass: {
					getAPI: (apiType) => glass.getAPI(apiType)
				},
				Logger: {
					getAPI: () => new Logger(this.glassContext).getAPI()
				}
			};
			const glassFeature = glass.getAPI();
			return Promise.all([
				this._initializeCapabilitiesFeature(glassFeature),
				glassFeature.getService('.DashboardPreferences'),
				glassFeature.getService('.Palette'),
				glassFeature.getService('.DashboardTheme'),
				glassFeature.getService('.DashboardSettings')
			]).then( ([capabilitiesService, dashboardPreferences, palette, dashboardTheme, dashboardSettings]) => {
				this.features['DashboardPreferences'] = {
					getAPI: () => dashboardPreferences.getAPI()
				};
				this.features['DashboardTheme'] = {
					getAPI: () => dashboardTheme.getAPI()
				};
				const userProfile = glassFeature.getCoreService('.DashboardCoreService').getFeature('UserProfile');
				this.features['UserProfile'] = {
					getAPI: () => userProfile.getAPI()
				};
				const paletteService = APIFactory.createAPI(palette,[PaletteAPI]);
				this.features['Palette'] = {
					getAPI: () => paletteService
				};
				this.features['DashboardSettings'] =  {
					getAPI: () => dashboardSettings.getAPI()
				};
				if (capabilitiesService) {
					this.features['Capabilities'] = {
						getAPI: () => capabilitiesService
					};
				}
				return this.features;
			});
		}


	}
	return GlassDashboardFactory;
});